import React from 'react'
import { useArticles } from 'services/ContentfulService/hooks/articles'
import { ContentfulConstraint } from 'services/ContentfulService/utils'
import { Article, summarizeArticle } from 'services/ContentfulService/models/articles'
import { ArticleCard } from '../ArticleCard'
import { StyledComponent } from '@emotion/styled'
import { PrioritizedContent } from 'experiences/shared/ContentfulImage/PriorityContext'

interface Props {
	constraints: ContentfulConstraint[]
	offset: number
	onNoMorePosts: () => void
	initialArticles?: Article[]
	WrapperComponent: StyledComponent<any>
	divider?: JSX.Element
}

const PAGE_SIZE = 7

const PriorityWrapper: React.FC<React.PropsWithChildren<{ priority: boolean }>> = ({ priority, children }) => {
	return priority ? <PrioritizedContent>{children}</PrioritizedContent> : <>{children}</>
}

export const PaginationFragment: React.FC<React.PropsWithChildren<Props>> = ({
	constraints,
	offset,
	onNoMorePosts,
	initialArticles,
	WrapperComponent,
	divider
}) => {
	const [articles, loading] = useArticles(
		{ constraints: constraints, count: PAGE_SIZE, offset: offset * PAGE_SIZE },
		initialArticles
	)
	// When we load a less than full page
	if (!loading && (!articles || articles.length < PAGE_SIZE)) {
		onNoMorePosts()
	}
	const items =
		articles?.map((article, index) => (
			<WrapperComponent key={article.id}>
				<PriorityWrapper priority={offset + index < 2}>
					<ArticleCard article={summarizeArticle(article)} mode={'responsive'} />
				</PriorityWrapper>
			</WrapperComponent>
		)) || []

	if (divider) items.splice(2, 0, divider)

	return loading ? <></> : <>{items}</>
}
